import { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { SafeResourceUrlService } from '../services/safe-resource-url.service';

@Pipe({
  name: 'safeHtml',
  standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly safeResourceUrlService: SafeResourceUrlService) {}
  transform(value) {
    return this.safeResourceUrlService.toSafeHtml(value);
  }
}
